import React from 'react';
import '../template-file-css/document-file-template.css';


export const EDU_MonthlyClinicalSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EDU_MonthlyClinicalSummary' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <b> Monthly Clinical Summary </b>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Medicaid Type: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Authorization Date: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Safety Plan Last Updated: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtMedicaidType' name='txtMedicaidType' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtAuthorizationDate' name='txtAuthorizationDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtSafetyPlan' name='txtSafetyPlan' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Biopsychosocial completed this month? </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Psychological completed this month? </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Nursing evaluation completed this month? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <select id='ddlBiopsychosocial' name='Biopsychosocial' className='add-only'>
                            <option value='NA'> N/A </option>
                            <option value='Yes'> Yes </option>
                            <option value='No'> No </option>
                        </select>
                        </td>
                        <td className='w-250'> <select id='ddlPsychological' name='Psychological' className='add-only'>
                            <option value='NA'> N/A </option>
                            <option value='Yes'> Yes </option>
                            <option value='No'> No </option>
                        </select>
                        </td>
                        <td className='w-250'> <select id='ddlNursingEvaluation' name='NursingEvaluation' className='add-only'>
                            <option value='NA'> N/A </option>
                            <option value='Yes'> Yes </option>
                            <option value='No'> No </option>
                        </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Psychiatric completed this month? </span> </td>
                        <td className='w-250'> <span className='eleHeader'> P.O. Worker/Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Referral Source: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <select id='ddlPsychiatric' name='Psychiatric' className='add-only'>
                            <option value='NA'> N/A </option>
                            <option value='Yes'> Yes </option>
                            <option value='No'> No </option>
                        </select>
                        </td>

                        <td className='w-250'> <input type='text' id='txtPoWorker' name='txtPoWorker' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtReferralSource' name='txtReferralSource' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Service Type: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> # of sessions scheduled this month: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date(s) of completed sessions: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtServiceType' name='txtServiceType' className='add-only' /> </td>
                        <td className='w-250'> <select id='ddlSessionsScheduled' name='SessionsScheduled' className='add-only'>
                            <option value='0'> 0 </option>
                            <option value='1'> 1 </option>
                            <option value='2'> 2 </option>
                            <option value='3'> 3 </option>
                            <option value='4'> 4 </option>
                            <option value='5'> 5 </option>
                            <option value='6'> 6 </option>
                            <option value='7'> 7 </option>
                            <option value='8'> 8 </option>
                            <option value='9'> 9 </option>
                            <option value='10'> 10 </option>
                        </select>
                        </td>
                        <td className='w-250'> <input type='text' id='txtDate' name='txtDate' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> # of community linkages provided this month: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Community Linkage Provided: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> ISP Last Updated: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <select id='ddlCommunityLinkages' name='CommunityLinkages' className='add-only'>
                            <option value='0'> 0 </option>
                            <option value='1'> 1 </option>
                            <option value='2'> 2 </option>
                            <option value='3'> 3 </option>
                            <option value='4'> 4 </option>
                            <option value='5'> 5 </option>
                            <option value='6'> 6 </option>
                            <option value='7'> 7 </option>
                            <option value='8'> 8 </option>
                            <option value='9'> 9 </option>
                            <option value='10'> 10 </option>
                        </select>
                        </td>

                        <td className='w-250'> <input type='text' id='txtProvided' name='txtProvided' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtIspLastUpdated' name='txtIspLastUpdated' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Will client be discharged within the next 30 days? </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Does client need to be reauthorized? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <select id='ddlClientDischarged' name='ClientDischarged' className='add-only'>
                            <option value='NA'> N/A </option>
                            <option value='Yes'> Yes </option>
                            <option value='No'> No </option>
                        </select>
                        </td>
                        <td className='w-375'> <select id='ddlReauthorized' name='Reauthorized' className='add-only'>
                            <option value='NA'> N/A </option>
                            <option value='Yes'> Yes </option>
                            <option value='No'> No </option>
                        </select>
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Narrative Summary </span>
                    <b> Instructions: </b> Please provide a brief summary of client's impulsive and defiant behaviors, progress toward goals including family interactions, level of cooperation with treatment, school, community, etc. The summary needs to include at least two (2), five (5) sentence paragraphs explicitly detailing the progress or lack of progress toward goals.
                </p>

                <p className='w-750'>
                    <textarea id='txtNarrativeSummary' name='txtNarrativeSummary' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Next Steps </span>
                    <b> Instructions: </b> Please provide a brief summary of any additional needs, recommendations, community linkages and new goals of treatment. This section should include a five (5) sentence paragraph which thoroughly details the next steps.
                </p>

                <p className='w-750'>
                    <textarea id='txtNextSteps' name='txtNextSteps' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Demographics </span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbInvolvement' name='cbInvolvement' className='add-only' value='DJJ Involvement' /> DJJ Involvement </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrtf' name='cbPrtf' className='add-only' value='PRTF' /> PRTF </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbProbation' name='cbProbation' className='add-only' value='Probation Violation' /> Probation Violation/Court
                            Retention
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCrisisCall' name='cbCrisisCall' className='add-only' value='Crisis Call' /> Crisis Call </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbElopement' name='cbElopement' className='add-only' value='Elopement/Wandering' /> Elopement/Wandering </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDfcsReport' name='cbDfcsReport' className='add-only' value='DFCS Report Made' /> DFCS Report Made </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAppearance' name='cbAppearance' className='add-only' value='Court Appearance' /> Court Appearance </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCritical' name='cbCritical' className='add-only' value='Critical Incident' /> Critical Incident </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHospitalized' name='cbHospitalized' className='add-only' value='Hospitalized' /> Hospitalized </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDfcsInvolvement' name='cbDfcsInvolvement' className='add-only' value='DFCS Involvement' /> DFCS Involvement </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Staff Present </span>
                    <textarea id='txtStaffPresent' name='txtStaffPresent' className='add-only'> </textarea>
                </p>

            </div>
        </form>

    )
}